"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_label_1 = require("@hotelplan/components.common.label");
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BaseCheckboxLabel = (0, styled_components_1.default)(components_common_label_1.Label)(({ theme }) => theme.forms.checkboxLabel || {}, ({ theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    'input:checked ~ .customCheckboxInput': {
        borderColor: colors.primary,
    },
    'input:checked ~ .customCheckboxInput::after': {
        opacity: 1,
    },
}), ({ disabled, theme: { colors } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.customCheckboxInput': {
        cursor: disabled ? 'default' : 'pointer',
    },
    '&:hover input ~ .customCheckboxInput': {
        backgroundColor: disabled ? colors.background : colors.lightGreySecond,
    },
    '&:hover input:checked ~ .customCheckboxInput': {
        backgroundColor: colors.background,
    },
}));
const CustomCheckboxControl = styled_components_1.default.span(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({}, theme.forms.customCheckboxControl) || {}));
const BaseCheckboxInput = styled_components_1.default.input.attrs({
    type: `checkbox`,
})((0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign({}, components_common_mixins_1.visuallyHidden)));
const Checkbox = props => {
    const { hideLabel = false, testId, labelTestId = '', content = '', disabled = false, onChange = noop_1.default, value = '', name, className, renderCustomControl: CustomControl = () => (react_1.default.createElement(CustomCheckboxControl, { className: "customCheckboxInput" })) } = props, inputProps = __rest(props, ["hideLabel", "testId", "labelTestId", "content", "disabled", "onChange", "value", "name", "className", "renderCustomControl"]);
    return (react_1.default.createElement(BaseCheckboxLabel, { hideLabel: hideLabel, disabled: disabled, className: className, "data-id": labelTestId },
        react_1.default.createElement(BaseCheckboxInput, Object.assign({ value: value, name: name || value.toString(), onChange: (e) => onChange(e.target.value, e), disabled: disabled, "data-id": testId }, inputProps)),
        content,
        react_1.default.createElement(CustomControl, Object.assign({}, props))));
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map